import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 有赞组件
import './vantInit'
// 全局样式
import './assets/styles/global.scss'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

window.IS_WX = navigator.userAgent.toLocaleLowerCase().includes('micromessenger')

window.mp3 = {
  rightAnswerMp3: `https://student.wqisland.com/static/students/right.mp3`,
  wrongAnswerMp3: `https://student.wqisland.com/static/students/wrong.mp3`,
  // dpRecountMp3: `https://web-cdn-bucket.oss-cn-shenzhen.aliyuncs.com/recount.mp3`
}

const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export default vm
